import axios from "axios";
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import "i18n/config";
import i18next from "i18next";

export const get = async (row:any, masterRow?:any) => {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/"+row.id+"/owners");
    return response.data;
};

export const update = async (row:any, masterRow?:any) => {
  let response = null;
  response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/"+masterRow.id+"/owners/update/"+row.id,row);
  return response.data;
};

export const bulkUpdate = async (assessment: string, search: string, user:string) => {
  let response = null;
  response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/"+assessment+"/owners/bulkUpdate",{search:search, user:user});
  return response.data;
};

export const destroy = async (id:any, masterRow?:any) => {
  let response = null;
  response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+masterRow.id+"/department/delete/"+id);
  return response.data;
};


export async function getColumns(locale: string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id_category', 
      headerName: i18next.t('Category'),
      flex: 2,
      valueGetter: params => params.row.subcategory.category.name || '',

    },
    {
      field: 'id_subcategory',
      headerName: i18next.t('Subcategory'),
      flex: 1,
      editable: false,
      type: 'string'
    },
    {
      field: 'id_user',
      headerName: i18next.t('Owner'),
      flex: 1,
      editable: true,
      type: 'singleSelect',
      valueOptions: [],
      valueGetter: params => params.row.id_user || '',
    },
    {
      field: 'updated_at',
      headerName: i18next.t('Updated'),
      type: 'date',
      valueGetter: params => moment(params.row.created_at).toDate(),
      valueFormatter: params => new Date(params?.value).toLocaleString(),
      flex: 1,
      maxWidth: 250,
      editable: false,
    }
  ] as GridColDef[];
};